import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import { FlagIssue } from '../../../config/utils';
import css from './chip.module.scss';
interface Props {
  issue: FlagIssue;
}
export function Chip(t0) {
  const $ = _c(6);
  const {
    issue
  } = t0;
  const t1 = issue.severity === "error";
  const t2 = issue.severity === "warning";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = cn(css.badge, {
      [css.error]: t1,
      [css.warning]: t2
    });
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== issue.rule || $[4] !== t3) {
    t4 = <span className={t3}>{issue.rule}</span>;
    $[3] = issue.rule;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}